// extracted by mini-css-extract-plugin
export default {"left-upload":"index_left-upload__dXxaC","right-upload":"index_right-upload__1+l71"};